export enum ICON_NAME {
  GENERAL_INFORMATION = 'GENERAL_INFORMATION',
  BANK_DETAILS = 'BANK_DETAILS',
  UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS',
  DEFAULT_STATUS = 'DEFAULT_STATUS',
  BACK_ARROW = 'BACK_ARROW',
  EXCLAMAITON = 'EXCLAMAITON',
  HOME = 'HOME',
  LEFTCHEVRON = 'LEFTCHEVRON',
  REFUND = 'REFUND',
  CIRCULARINFO = 'CIRCULARINFO',
  LIGHTNING = 'LIGHTNING',
  COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD',
  COMMENT = 'COMMENT',
  CHEVRONDOWN = 'CHEVRONDOWN',
  CLOSE = 'CLOSE',
  GREEN_TICK = 'GREEN_TICK',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  BOX = 'BOX',
  CLOSE_SMALL = 'CLOSE_SMALL',
  ALERT = 'ALERT',
  EDIT = 'EDIT',
  ACTIVATE = 'ACTIVATE',
  DOWNLOAD = 'DOWNLOAD',
  RETRY = 'RETRY',
  DEVELOPERS = 'DEVELOPERS',
  PAYMENT_LINKS = 'PAYMENT_LINKS',
  PAYMENT_FORMS = 'PAYMENT_FORMS',
  PAYMENT_BUTTONS = 'PAYMENT_BUTTONS',
  CUSTOMERS = 'CUSTOMERS',
  PRODUCT_LINKS = 'PRODUCT_LINKS',
  REPORTS = 'REPORTS',
  API_KEYS = 'API_KEYS',
  SETTLEMENTS = 'SETTLEMENTS',
  SUMMARY = 'SUMMARY',
  TRANSACTIONS = 'TRANSACTIONS',
  SHARE = 'SHARE',
  OPEN_LINK = 'OPEN_LINK',
  ADDITION = 'ADDITION',
  SUBTRACT = 'SUBTRACT',
  UPLOAD_CLOUD = 'UPLOAD_CLOUD',
  MOVE_DOWN = 'MOVE_DOWN',
  NUMBER = 'NUMBER',
  MULTILINE_TEXT = 'MULTILINE_TEXT',
  TEXT = 'TEXT',
  DELETE = 'DELETE',
  GREEN_TICK_BIG = 'GREEN_TICK_BIG',
  MORE_INFO = 'MORE_INFO',
  CSV_FILE = 'CSV_FILE',
  CLOSE_NORMAL = 'CLOSE_NORMAL',
  SETTINGS = 'SETTINGS',
  VISA = 'VISA',
  RUPAY = 'RUPAY',
  MASTERCARD = 'MASTERCARD',
  MAESTRO = 'MAESTRO',
  AMEX = 'AMEX',
  DINERS = 'DINERS',
  HDFC = 'HDFC',
  KOTAK = 'KOTAK',
  ICICI = 'ICICI',
  PAYPAL = 'PAYPAL',
  ZESTMONEY = 'ZESTMONEY',
  YESBANK = 'YESBANK',
  SBI = 'SBI',
  INDUSIND = 'INDUSIND',
  AMAZONPAY = 'AMAZONPAY',
  STANDARD_CHARTERED = 'STANDARD_CHARTERED',
  OLAMONEY = 'OLAMONEY',
  PHONEPE = 'PHONEPE',
  FREECHARGE = 'FREECHARGE',
  JIOMONEY = 'JIOMONEY',
  MOBIKWIK = 'MOBIKWIK',
  AIRTEL_MONEY = 'AIRTEL_MONEY',
  PAYTM = 'PAYTM',
  NETBANKING = 'NETBANKING',
  NAVIGATE_TO = 'NAVIGATE_TO',
  EASY_SPLIT = 'EASY_SPLIT',
  DELETE_INFO = 'DELETE_INFO',
  ACTIVE_STATUS = 'ACTIVE_STATUS',
  INACTIVE_STATUS = 'INACTIVE_STATUS',
  CIRCULAR_CLOSE = 'CIRCULAR_CLOSE',
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  DELETE_SPLIT = 'DELETE_SPLIT',
  CIRCULAR_PENDING = 'CIRCULAR_PENDING',
  EPOS_ACTIVE = 'EPOS_ACTIVE',
  EPOS_INACTIVE = 'EPOS_INACTIVE',
  CREDITCARD = 'CREDITCARD',
  UPI = 'UPI',
  WALLET = 'WALLET',
  INSTACRED = 'INSTACRED',
  AXIS = 'AXIS',
  LAZY_PAY = 'LAZY_PAY',
  INTERNATIONAL_CARDS = 'INTERNATIONAL_CARDS',
  BOB = 'BOB',
  TEST = 'TEST',
  ALERT_INFO = 'ALERT_INFO',
  REMOVE_BUTTON = 'REMOVE_BUTTON',
  ADD_BUTTON = 'ADD_BUTTON',
  ELLIPSIS_HORIZONTAL = 'ELLIPSIS_HORIZONTAL',
  ATTACH = 'ATTACH',
  UPLOAD_ICON = 'UPLOAD_ICON',
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  PLANS = 'PLANS',
  BULK_SUBSCRIPTIONS = 'BULK_SUBSCRIPTIONS',
  IMPORT_MANDATES = 'IMPORT_MANDATES',
  BULK_PAYMENTS = 'BULK_PAYMENTS',
  NEWTAB = 'NEWTAB',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  WHATSAPP = 'WHATSAPP',
  WHATSAPP_GREEN = 'WHATSAPP_GREEN',
  LINK = 'LINK',
  CAMERA = 'CAMERA',
  REFRESH = 'REFRESH',
  INFO = 'INFO',
  DOWNLOAD_OUTLINE = 'DOWNLOAD_OUTLINE',
  URL = 'URL',
  VISIBILITY = 'VISIBILITY',
  CANCEL = 'CANCEL',
  SOFTPOS = 'SOFTPOS',
  SEND = 'SEND',
  OPTIONAL = 'OPTIONAL',
  DOWNTIME = 'DOWNTIME',
  TIMER = 'TIMER',
  GOOGLE_PLAY = 'GOOGLE_PLAY',
  DESKTOP = 'DESKTOP',
  RADIO = 'RADIO',
  ELLIPSE = 'ELLIPSE',
  LINE = 'LINE',
  DOTTED_LINE = 'DOTTED_LINE',
  GREEN_TICK_SMALL = 'GREEN_TICK_SMALL',
  SERVICE_ALERTS = 'SERVICE_ALERTS',
  WEBHOOKS = 'WEBHOOKS',
  API_LOGS = 'API_LOGS',
  WHITELISTING = 'WHITELISTING',
  RATE_LIMITS = 'RATE_LIMITS',
  INTEGRATION_USAGE = 'INTEGRATION_USAGE',
  SWITCH = 'SWITCH',
  ROUTER = 'ROUTER',
  FILE_FORMAT = 'FILE_FORMAT',
  BHIM_UPI = 'BHIM_UPI',
  GOOGLE_PAY = 'GOOGLE_PAY',
  KREDITBEE = 'KREDITBEE',
  SIMPL = 'SIMPL',
  CITI = 'CITI',
  IDFC = 'IDFC',
  EPAYLATER = 'EPAYLATER',
  OXIGEN = 'OXIGEN',
  HDFC_PAYLATER = 'HDFC_PAYLATER',
  FEDERAL = 'FEDERAL',
  HOME_CREDIT = 'HOME_CREDIT',
  G_PLAY = 'G_PLAY',
  A_APP = 'A_APP',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  CRED = 'CRED',
  DELHIVERY = 'DELHIVERY',
  DREAM11 = 'DREAM11',
  IRCTC = 'IRCTC',
  NYKAA = 'NYKAA',
  ZOMATO = 'ZOMATO',
  FORWARD_ARROW = 'FORWARD_ARROW',
  EYE = 'EYE',
  EYE_SLASH = 'EYE_SLASH',
  OFFERS = 'OFFERS',
  DATE = 'DATE',
  SEARCH = 'SEARCH',
  WHATSAPP_PAYMENT_MODE = 'WHATSAPP_PAYMENT_MODE',
  APPS = 'APPS',
  SHOPIFY = 'SHOPIFY',
  SLACK = 'SLACK',
  FAILED_BIG = 'FAILED_BIG',
  ROUTER_ANALYTICS = 'ROUTER_ANALYTICS',
  ARROW = 'ARROW',
  DOT = 'DOT',
  ACTIVE_DOT = 'ACTIVE_DOT',
  ERROR = 'ERROR',
  UPLOAD_CLOUD_SM = 'UPLOAD_CLOUD_SM',
  FILE = 'FILE',
  VERIFIED = 'VERIFIED',
  QR_CODE = 'QR_CODE',
  INTEGRATION_FORM = 'INTEGRATION_FORM',
  EXCLUSIVE_ACCESS = 'EXCLUSIVE_ACCESS',
  RIGHT_ARROW = 'RIGHT_ARROW',
  LEFT_ARROW = 'LEFT_ARROW',
  FLASH = 'FLASH',
  CASHFREE_LOGO = 'CASHFREE_LOGO',
  BANK_LOGO = 'BANK_LOGO',
  EXPAND = 'EXPAND',
  BLOCK = 'BLOCK',
  INSUFFICIENT_EVIDENCE = 'INSUFFICIENT_EVIDENCE',
  PUNJAB_AND_SIND_BANK = 'PUNJAB_AND_SIND_BANK',
  PUNJAB_NATIONAL_BANK = 'PUNJAB_NATIONAL_BANK',
  RBL = 'RBL',
  SARASWAT_BANK = 'SARASWAT_BANK',
  DHANLAXMI_BANK = 'DHANLAXMI_BANK',
  UNION_BANK = 'UNION_BANK',
  CANARA_BANK = 'CANARA_BANK',
  BANK_OF_MAHARASHTRA = 'BANK_OF_MAHARASHTRA',
  CSB_BANK = 'CSB_BANK',
  CITY_UNION_BANK = 'CITY_UNION_BANK',
  DEUTSCHE_BANK = 'DEUTSCHE_BANK',
  DCB_BANK = 'DCB_BANK',
  IDBI = 'IDBI',
  INDIAN_BANK = 'INDIAN_BANK',
  JAMMU_AND_KASHMIR_BANK = 'JAMMU_AND_KASHMIR_BANK',
  KARNATAKA_BANK = 'KARNATAKA_BANK',
  KARUR_VYSYA_BANK = 'KARUR_VYSYA_BANK',
  LAKSHMI_VILAS_BANK = 'LAKSHMI_VILAS_BANK',
  SOUTH_INDIAN_BANK = 'SOUTH_INDIAN_BANK',
  TAMILNAD_MERCANTILE_BANK = 'TAMILNAD_MERCANTILE_BANK',
  UCO_BANK = 'UCO_BANK',
  SHIVALIK_BANK = 'SHIVALIK_BANK',
  UTKARSH_BANK = 'UTKARSH_BANK',
  AU_BANK = 'AU_BANK',
  EQUITAS_BANK = 'EQUITAS_BANK',
  HSBC = 'HSBC',
  BANK_OF_INDIA = 'BANK_OF_INDIA',
  DBS_BANK = 'DBS_BANK',
  INDIAN_OVERSEAS_BANK = 'INDIAN_OVERSEAS_BANK',
  GSC_BANK = 'GSC_BANK',
  SURAT_PEOPLE_BANK = 'SURAT_PEOPLE_BANK',
  BANDHAN_BANK = 'BANDHAN_BANK',
  SVC_BANK = 'SVC_BANK',
  TNSC_BANK = 'TNSC_BANK',
  CENTRAL_BANK_OF_INDIA = 'CENTRAL_BANK_OF_INDIA',
  ROUNDED_ADD = 'ROUNDED_ADD',
  ROUNDED_CROSS = 'ROUNDED_CROSS',
  ROUTER_V2 = 'ROUTER_V2',
  APPS_V2 = 'APPS_V2',
  QUICK_ACTIVATE = 'QUICK_ACTIVATE',
  LOCK = 'LOCK',
  WALLET_BANNER = 'WALLET_BANNER',
  WALLET_REFUND = 'WALLET_REFUND',
  FEE_WALLET = 'FEE_WALLET',
  HOUR_GLASS = 'HOUR_GLASS',
  CLOCK = 'CLOCK',
  STARS = 'STARS',
  INCIDENT_WARNING = 'INCIDENT_WARNING',
  NO_INCIDENT = 'NO_INCIDENT',
  STATUS_PAGE = 'STATUS_PAGE',
  HELP = 'HELP',
  STOREFRONT = 'STOREFRONT',
  AGENT = 'AGENT',
  TICK_WITH_CIRCLE = 'TICK_WITH_CIRCLE',
  SUCCESS_TICK = 'SUCCESS_TICK',
  RIGHT_BUTTON = 'RIGHT_BUTTON',
  LEFT_BUTTON = 'LEFT_BUTTON',
  RISKSHIELD = 'RISKSHIELD',
  PIGI_BANK = 'PIGI_BANK',
  FLOWWISE = 'FLOWWISE',
  BAR_GRAPH = 'BAR_GRAPH',
  DOCUMENT = 'DOCUMENT',
  CUSTOMER_LIFECYCLE_ANALYSIS = 'CUSTOMER_LIFECYCLE_ANALYSIS',
  CASHFREE_FULL_LOGO = 'CASHFREE_FULL_LOGO',
  CCAVENUE = 'CCAVENUE',
  PAYU = 'PAYU',
  RAZORPAY = 'RAZORPAY',
  TECHPROCESS = 'TECHPROCESS',
  DELTA_ARROW_UP = 'DELTA_ARROW_UP',
  DELTA_ARROW_DOWN = 'DELTA_ARROW_DOWN',
  CHART_LINE = 'CHART_LINE',
  SAND_TIMER = 'SAND_TIMER',
  ATOM = 'ATOM',
  ROCKET = 'ROCKET',
  SIDE_ARROW = 'SIDE_ARROW',
  WARNING = 'WARNING',
  URGENT = 'URGENT',
  MOBILE = 'MOBILE',
  BRANDING_DESKTOP = 'BRANDING_DESKTOP',
  RESTORE = 'RESTORE',
  TIGHT_DISPLAY = 'TIGHT_DISPLAY',
  MEDIUM_DISPLAY = 'MEDIUM_DISPLAY',
  LOOSE_DISPLAY = 'LOOSE_DISPLAY',
  JOINT_DISPLAY = 'JOINT_DISPLAY',
  SPACED_DISPLAY = 'SPACED_DISPLAY',
  FULL_SIZE_CARD_DISPLAY = 'FULL_SIZE_CARD_DISPLAY',
  MEDIUM_SIZE_CARD_DISPLAY = 'MEDIUM_SIZE_CARD_DISPLAY',
  INPUT_ALL_SIDES_DISPLAY = 'INPUT_ALL_SIDES_DISPLAY',
  INPUT_BOTTOM_DISPLAY = 'INPUT_BOTTOM_DISPLAY',
  INPUT_THREE_SIDES_DISPLAY = 'INPUT_THREE_SIDES_DISPLAY',
  OUTLINED_ICON = 'OUTLINED_ICON',
  THREE_DIMENSIONAL_ICON = 'THREE_DIMENSIONAL_ICON',
  FILLED_ICON = 'FILLED_ICON',
  CHECKOUT_ANALYTICS = 'CHECKOUT_ANALYTICS',
  VBA = 'VBA',
  STAR = 'STAR',
  REPLAY = 'REPLAY',
  PLAY = 'PLAY',
  PLAY_CIRCLE = 'PLAY_CIRCLE',
  BOOK = 'BOOK',
  APP_STORE = 'APP_STORE',
  PLAY_STORE = 'PLAY_STORE',
  APP_QR_CODE = 'APP_QR_CODE',
  MOBILE_APP_IN_HAND = 'MOBILE_APP_IN_HAND',
  GENERIC_FILE = 'GENERIC_FILE',
  ECOM_360 = 'ECOM_360',
  LIVE = 'LIVE',
  ECOM_360_LOGO = 'ECOM_360_LOGO',
  EMBEDDABLE_COMPONENTS = 'EMBEDDABLE_COMPONENTS',
  TEST_CONFIG = 'TEST_CONFIG',
  DRAG_AND_DROP = 'DRAG_AND_DROP',
  RETURN_TO_MERCHANT_PAGE = 'RETURN_TO_MERCHANT_PAGE',
  RETRY_PAYMENT = 'RETRY_PAYMENT',
  UPI_PAYMENT_ICON = 'UPI_PAYMENT_ICON',
  CARD_PAYMENT_ICON = 'CARD_PAYMENT_ICON',
  BNPL_PAYMENT_ICON = 'BNPL_PAYMENT_ICON',
  WALLET_PAYMENT_ICON = 'WALLET_PAYMENT_ICON',
  PAYPAL_PAYMENT_ICON = 'PAYPAL_PAYMENT_ICON',
  CARD_EMI_PAYMENT_ICON = 'CARD_EMI_PAYMENT_ICON',
  NET_BANKING_PAYMENT_ICON = 'NET_BANKING_PAYMENT_ICON',
  CARDLESS_EMI_PAYMENT_ICON = 'CARDLESS_EMI_PAYMENT_ICON',
  BANK_TRANSFER_PAYMENT_ICON = 'BANK_TRANSFER_PAYMENT_ICON',
  BHARATX_EMI_PAYMENT_ICON = 'BHARATX_EMI_PAYMENT_ICON',
  COD_PAYMENT_ICON = 'COD_PAYMENT_ICON',
  STACKED_POINTER = 'STACKED_POINTER',
  SPARKLES = 'SPARKLES',
  INSIGHTS_AI = 'INSIGHTS_AI',
  ROUTER_GATEWAYS = 'ROUTER_GATEWAYS',
  ROUTER_CONIGURATION = 'ROUTER_CONIGURATION',
  AI_CHECKOUT_PERSONALISATION = 'AI_CHECKOUT_PERSONALISATION',
  CHECKOUT_CUSTOMISATIONS = 'CHECKOUT_CUSTOMISATIONS',
  WEBSITE = 'WEBSITE',
  REFLECT_PLAY = 'REFLECT_PLAY',
  CUSTOM_ROUTING = 'CUSTOM_ROUTING',
  SUCCESS_ROUTING = 'SUCCESS_ROUTING',
  VOLUME_ROUTING = 'VOLUME_ROUTING',
  LOCATION = 'LOCATION',
  PERSON = 'PERSON',
  DOCUMENTS = 'DOCUMENTS',
  USER = 'USER',
  MAIL = 'MAIL',
  CLOUDSYNC = 'CLOUDSYNC',
  CHECKCIRCLE = 'CHECKCIRCLE',
  WARNINGNEW = 'WARNINGNEW',
  RADIO_BOX_ICON = 'RADIO_BOX_ICON',
  FILLED_INFO = 'FILLED_INFO',
  PERCENTAGE = 'PERCENTAGE',
  SEAL_WARNING = 'SEAL_WARNING',
  SEAL_SUCCESS = 'SEAL_SUCCESS',
}

export type ICON_NAME_TYPE = keyof typeof ICON_NAME;

export type IconProps = {
  // To be changed to ICON_NAME_TYPE after all string instances are restricted to ICON_NAME_TYPE
  componentName: string;
  [key: string]: any;
};
